export const UPDATE_SUBSCRIBE = "UPDATE_SUBSCRIBE";

export const UPDATE_NEWSLETTER = "UPDATE_NEWSLETTER";